import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import ConnectToLeadingDataImage from './ConnectToLeadingDataImage'

const copy = {
  heading: `Connect to the leading cloud data warehouses`,
  description: `Sync Segment profiles to your cloud data warehouse of choice within minutes.`,
}

const ConnectToLeadingData = () => {
  return (
    <SectionBase variant="2Col" reverse={true}>
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h3">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ConnectToLeadingDataImage />
      </Section.Contents>
    </SectionBase>
  )
}

export default ConnectToLeadingData
